import React from "react";

const PortfolioCard = ({ category, mainClass, imgSrc, projectUrl }) => {
  return (
    <>
      <div className={mainClass}>
        <div className="portfolio-item">
          <div className="portfolio-img">
            <img src={`./web/images/works/${imgSrc}`} alt="portfolio" className="img-responsive" />
            
          </div>
          <div className="portfolio-overlay">
            <div className="overlay-content">
              <div className="overlay-content-item">
                <p className="category">{category}</p>
                {/* <a href={projectUrl} target="_blank" rel="noopener noreferrer">
                  <div className="magnify-icon">
                    <p>
                      <span>
                        <i className="fa fa-link" aria-hidden="true"></i>
                      </span>
                    </p>
                  </div>
                </a> */}
                {/* <a href={`./web/images/works/${imgSrc}`} data-lightbox="image-1">
                  <div className="magnify-icon">
                    <p>
                      <span>
                        <i className="fa fa-search" aria-hidden="true"></i>
                      </span>
                    </p>
                  </div>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PortfolioCard;
